import './js/aos';
import { bodyUtils, formUtils, counterUtils, windowScrollUtils } from './js/body';
import './js/sliders';
import { sliderUtils } from './js/sliders';

$(document).ready(function() {
  counterUtils();
  sliderUtils();
});

$(window).on('load', function() {
  bodyUtils();
  formUtils();
  windowScrollUtils();
});

$(window).on('resize', function() {
  counterUtils();
});

$(window).on('scroll', function() {
  counterUtils();
  windowScrollUtils();
});

$(document).on('gform_page_loaded', function(event, form_id, current_page) {
  formUtils();
});

$(document).on('gform_post_conditional_logic', function(event, form_id, current_page) {
  formUtils();
});
